export enum AlertStatus {
  Resolved = 'resolved',
  Unresolved = 'unresolved',
}
